import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-global_icon_back",
  "use": "icon-global_icon_back-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-global_icon_back\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\" /><path d=\"M13.224 4.436a.6.6 0 0 0-.848 0l-5.94 5.94a.6.6 0 0 0 0 .848l5.94 5.94a.6.6 0 0 0 .848-.849L7.71 10.8l5.515-5.515a.6.6 0 0 0 0-.849Z\" fill=\"#404040\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol